import { AnimatePresence, motion } from 'framer-motion';
import { type INotification } from '@/types/INotification';
import {
  PANEL_ITEM_VARIANTS,
  TOAST_TRANSITION
} from '@/components/OrderToastStack/toastMotion';
import { NotificationItem } from '../NotificationItem/NotificationItem';
import styles from './notificationPanel.module.scss';

interface INotificationPanelProps {
  notifications: INotification[];
  hasUnread: boolean;
  onSelect: (path: string, id: string) => void;
  onMarkAllRead: () => void;
  onClearAll: () => void;
}

/**
 * Панель-история уведомлений (popover под колокольчиком). Рендерит историю
 * за сегодняшний день через реестр карточек, держит действия «прочитать все»
 * и «очистить». Прочитанные записи остаются приглушёнными, не пропадают.
 */
export const NotificationPanel: React.FC<INotificationPanelProps> = ({
  notifications,
  hasUnread,
  onSelect,
  onMarkAllRead,
  onClearAll
}) => (
  <div className={styles['notification-panel']}>
    <div className={styles['notification-panel__header']}>
      <span className={styles['notification-panel__title']}>Уведомления</span>
      <div className={styles['notification-panel__actions']}>
        <button
          type="button"
          className={styles['notification-panel__action']}
          onClick={onMarkAllRead}
          disabled={!hasUnread}
        >
          Прочитать все
        </button>
        <button
          type="button"
          className={styles['notification-panel__action']}
          onClick={onClearAll}
          disabled={notifications.length === 0}
        >
          Очистить
        </button>
      </div>
    </div>

    {notifications.length === 0 ? (
      <p className={styles['notification-panel__empty']}>
        Пока нет уведомлений
      </p>
    ) : (
      <div className={styles['notification-panel__list']}>
        <AnimatePresence initial={false}>
          {notifications.map((notification) => (
            <motion.div
              key={notification.id}
              layout
              variants={PANEL_ITEM_VARIANTS}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={TOAST_TRANSITION}
            >
              <NotificationItem
                notification={notification}
                onSelect={onSelect}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    )}
  </div>
);
